import analytics from 'analytics.js';
import events from 'events.js';

import 'ko/bindings/href.js';
import 'ko/bindings/tooltip.js';

function setupMobilePracticeToggle() {
    const elems = Array.from(
        document.getElementsByClassName('js-mobile-details'),
    );
    for (const elem of elems) {
        const pracId = `practice-${elem.dataset.practice}`;
        const pracFooterInfo = document.getElementById(pracId);
        const pracFooterBtn = document.getElementById(`${pracId}-more-info`);
        const icon = pracFooterBtn.querySelector('i');

        events.listen(pracFooterBtn, 'click', function () {
            for (const e of Array.from(
                document.getElementsByClassName('more-info'),
            )) {
                e.style.display = 'none';
            }
            icon.classList.remove('fa-angle-double-up');
            icon.classList.add('fa-angle-double-down');
            if (elem.classList.contains('expanded')) {
                elem.classList.remove('expanded');
                pracFooterInfo.style.display = 'none';
            } else {
                for (const e of elems) {
                    e.classList.remove('expanded');
                }
                elem.classList.add('expanded');
                pracFooterInfo.style.display = 'block';
                icon.classList.remove('fa-angle-double-down');
                icon.classList.add('fa-angle-double-up');
            }
        });
    }
}

function setupViewMoreLinks() {
    for (const elem of document.querySelectorAll('a.view-more')) {
        events.listen(elem, 'click', function () {
            if (elem.textContent.indexOf('more') === -1) {
                elem.textContent = 'Show more';
            } else {
                elem.textContent = 'Show less';
            }
            for (const e of elem.parentNode.childNodes) {
                if (
                    e.classList &&
                    (e.classList.contains('preview') ||
                        e.classList.contains('full-text'))
                ) {
                    e.classList.toggle('hidden');
                }
            }
        });
    }
}

function setupShowDetail() {
    const showDetails = Array.from(
        document.getElementsByClassName('show-details'),
    );
    for (const el of showDetails) {
        events.listen(el, 'click', () => {
            const sE = el.getElementsByClassName('status')[0];
            sE.innerText = sE.innerText === 'View ' ? 'Hide ' : 'View ';
            for (const cN of el.parentNode.childNodes) {
                if (cN.className && cN.className.includes('extra-info')) {
                    if (cN.style.display === 'none') {
                        cN.style.display = 'block';
                    } else {
                        cN.style.display = 'none';
                    }
                }
            }
            for (const elm of Array.from(el.getElementsByTagName('i'))) {
                if (elm.className.includes('fa-angle-down')) {
                    elm.classList.remove('fa-angle-down');
                    elm.classList.add('fa-angle-up');
                } else if (elm.className.includes('fa-angle-up')) {
                    elm.classList.remove('fa-angle-up');
                    elm.classList.add('fa-angle-down');
                }
            }
        });
    }
}

function setupContactBarScroll() {
    const footer = document.getElementsByClassName('fix-footer')[0];
    if (!footer) {
        return;
    }

    events.listen(document, 'scroll', function () {
        const bar = document.getElementById('contact-bar');
        if (!bar) {
            return;
        }
        const bound = bar.getBoundingClientRect();
        if (bound.bottom < 0) {
            footer.style.display = 'block';
            footer.classList.remove('slideOutDown');
            footer.classList.add('slideInUp');
        } else {
            footer.classList.remove('slideInUp');
            footer.classList.add('slideOutDown');
        }
        const windowBottom = window.innerHeight + document.body.scrollTop;
        if (
            document.body.offsetHeight <= windowBottom &&
            window.innerWidth > 768
        ) {
            footer.classList.remove('slideInUp');
            footer.classList.add('slideOutDown');
        }
    });
}

function trackWebsiteClick(event) {
    const elem = event.currentTarget;
    analytics.track('openPracticePositionWebsite', {
        website: elem.dataset.trackWebsite,
        practice_position: elem.dataset.position,
    });
}

(async function () {
    await events.ready();

    setupContactBarScroll();
    setupMobilePracticeToggle();
    setupViewMoreLinks();
    setupShowDetail();
    events.listen(
        Array.from(document.querySelectorAll('[data-track-website]')),
        'click',
        trackWebsiteClick,
    );
})();
